import React, { useEffect, useState } from "react";
import _ from "underscore";
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

function Row(props) {
    const { row } = props;
    const [open, setOpen] = React.useState(false);
    const [plantLocation, setPlantLocation] = React.useState("");

    useEffect(() => {
        const a = _.map(row.plants, function (b) {
            return b.location.lat + "," + b.location.lng;
        })
        setPlantLocation(a.join(";"));
    }, [row]);

    return (
        <React.Fragment>
            <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                <TableCell>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpen(!open)}
                    >
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell component="th" scope="row">
                    {row.order_no}
                </TableCell>
                <TableCell align="right">{row.product_sku}</TableCell>
                <TableCell align="right">{row.order_qty}</TableCell>
                <TableCell align="right">
                    <a href={`/routing-map?cus=${row?.customer_location?.lat},${row?.customer_location?.lng}&plt=${plantLocation}&veh=${row?.vehicle_location?.lat},${row?.vehicle_location?.lng}`}>
                        {row.vehicle_number}
                    </a></TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{ margin: 1 }}>
                            <Typography variant="h6" gutterBottom component="div">
                                Plant
                            </Typography>
                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Plant Code</TableCell>
                                        <TableCell>Available Stock</TableCell>
                                        <TableCell align="right">Supplied Qty</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {row.plants.map((plant, i) => (
                                        <TableRow key={`plant` + i}>
                                            <TableCell component="th" scope="row">
                                                {plant.plant_code}
                                            </TableCell>
                                            <TableCell>{plant.available_stock}</TableCell>
                                            <TableCell align="right">{plant.supplied_units}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

export default function CollapsibleTable(props) {
    const { data } = props;
    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        const dt = _.map(data.logistic_data, function (a) {
            return {
                customer_name: a.customer.customer_name,
                edd: a.customer.edd,
                customer_id: a.customer.id,
                customer_location: a.customer.location,
                order_date: a.customer.order_date,
                order_no: a.customer.order_no,
                order_qty: a.customer.order_qty,
                order_status: a.customer.order_status,
                product_sku: a.customer.product_sku,
                vehicle_avg_distance_per_day: a.vehicle.avg_distance_per_day,
                vehicle_base_location: a.vehicle.base_location,
                vehicle_capacity: a.vehicle.capacity,
                vehicle_location: a.vehicle.location,
                vehicle_type: a.vehicle.type,
                vehicle_id: a.vehicle.vehicle_id,
                vehicle_number: a.vehicle.vehicle_number,
                plants: a.plants
            };
        });
        setTableData(dt);
    }, [data]);

    return (
        <TableContainer component={Paper}>
            <Table aria-label="collapsible table">
                <TableHead>
                    <TableRow>
                        <TableCell />
                        <TableCell>Order Id</TableCell>
                        <TableCell align="right">Product SKU</TableCell>
                        <TableCell align="right">Order Qty</TableCell>
                        <TableCell align="right">Vehicle Number</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {tableData?.map((row) => (
                        <Row key={row.name} row={row} />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}